module.exports = __webpack_public_path__ + "static/media/small-logo-purple.81ff8c64.svg";